module.exports = __webpack_public_path__ + "img/GreennClub.3794c657.svg";